import { useState } from "react";
import PageLayout from "./PageLayout ";
import axios from "axios";
import { toast } from "react-toastify";
import { api_url } from "../../url";

export default function ReportIssue() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  // handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${api_url}/api/v1/contactus/add/contact`,
        formData,
      );

      toast.success("Query submitted successfully!");

      setFormData({ name: "", mobile: "", email: "", message: "" });
    } catch (err) {
      toast.error(err.response?.data?.message || "Submission failed");
      console.error(err);
    }
  };
  return (
    <PageLayout
      title="Report Issues & Violations"
      desc="Raise your concerns responsibly. We are here to support lawful and structured reporting."
    >
      <div className="advocacy-content">
        <p>
          Reporting legal issues and violations is an important step towards
          ensuring justice, accountability, and social responsibility. At ICSAJ
          (International Council of Sanatan Advocacy & Justice), we provide a
          structured and responsible platform where individuals can report
          concerns related to legal violations, social injustice, or unlawful
          activities.
        </p>

        <p>
          Our objective is to ensure that every concern is heard, reviewed, and
          addressed through proper legal channels. We encourage individuals to
          report issues with accuracy, clarity, and responsibility. All
          submissions are handled with confidentiality and are reviewed by our
          team for appropriate action.
        </p>

        <p>
          Whether it involves violation of rights, social injustice, or legal
          disputes, your report can contribute towards awareness and corrective
          action. By reporting responsibly, you play a role in strengthening the
          legal system and promoting a just society.
        </p>

        <h4 className="mt-4">Submit Your Report</h4>

        {/* FORM */}
        <form className="report-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                className="form-control"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                className="form-control"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="mobile"
                placeholder="Phone Number"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-12 mb-3">
              <textarea
                name="message"
                rows="5"
                placeholder="Describe the issue in detail..."
                className="form-control"
                onChange={handleChange}
                required
              ></textarea>
            </div>
          </div>

          <div className="text-center">
            <button type="submit" className="btn btn-danger px-4 py-2">
              Submit Report
            </button>
          </div>
        </form>
      </div>
    </PageLayout>
  );
}
